/**
 * Module: `export/response-export-document.ts` — shared export model for PDF/DOCX.
 */

import type { SourceType } from "@/types";

/** Display title used in PDF and Word exports. */
export const RESPONSE_EXPORT_TITLE = "Réponse SidonIAssist";

/** Entête légale systématique (PDF, DOCX, presse-papiers, page /share). */
export const RESPONSE_EXPORT_DISCLAIMER =
  "La CNCC ne saurait en aucun cas être tenue responsable de la réutilisation des Sources tierces à Sidoni, notamment par lien URL, ou des restrictions applicables à certaines Sources, le cas échéant.";

export type ResponseExportSourceType =
  | "SIDONI"
  | "Légifrance"
  | "ANC"
  | "H2A"
  | "MaCNCC"
  | "CNCC"
  | "Formation"
  | "other";

export interface ResponseExportLink {
  label: string;
  url: string;
}

export interface ResponseExportLinkedResource {
  title: string;
  url: string;
}

export interface ResponseExportArticleRef {
  nouveau: string;
  ancien?: string | null;
}

export interface ResponseExportSource {
  title: string;
  url?: string;
  links?: ResponseExportLink[];
  datePublication?: string;
  dateMiseAJour?: string;
  /** @deprecated Prefer datePublication / dateMiseAJour; kept for markdown fallbacks. */
  date?: string;
  summary?: string;
  sourceType?: ResponseExportSourceType;
  documentType?: string;
  classeDocument?: string;
  avertissementDocument?: string;
  articleRefs?: ResponseExportArticleRef[];
  piecesJointes?: ResponseExportLinkedResource[];
  outilsLies?: ResponseExportLinkedResource[];
}

export interface ResponseExportSourceCategory {
  type: SourceType | "other";
  label: string;
  sources: ResponseExportSource[];
}

export interface ResponseExportDocument {
  title: string;
  exportedAt: string;
  question: {
    text: string;
  };
  /** Answer body markdown without trailing `### Source …` sections. */
  answerMarkdown: string;
  /** Grouped sources (chat order); empty categories are omitted. */
  sourceCategories: ResponseExportSourceCategory[];
  disclaimer?: string;
}

export type ResponseExportFormat = "pdf" | "docx";

/** Flat list helper for callers that do not need category headers. */
export function flattenExportSources(
  doc: ResponseExportDocument
): ResponseExportSource[] {
  return doc.sourceCategories.flatMap((category) => category.sources);
}
